import {isEmpty} from 'lodash';

export default {
  profileLoadingState(state) {
    return state.profileLoadingState;
  },
  profileErrorState(state) {
    return state.profileErrorState;
  },
  profileDetailsState(state) {
    return state.profileDetailsState;
  },
  profileUpdateLoadingState(state) {
    return state.profileUpdateLoadingState;
  },
  isProfilePublished(state) {
    return state.profileDetailsState.status === 'active';
  },
  isProfileCompleted(state) {
    return state.profileDetailsState.profile_completeness_progress === 100;
  },
  isResumeFileUploaded(state) {
    return !isEmpty(state.profileDetailsState) && state.profileDetailsState.resume_file_name;
  },
  isReferralCreationPending(state) {
    return (
      state.profileDetailsState.referral_creation && state.profileDetailsState.referral_creation.status === 'pending'
    );
  },
  isReferralCreationUnqualified(state) {
    return (
      state.profileDetailsState.referral_creation &&
      state.profileDetailsState.referral_creation.status === 'unqualified'
    );
  },
  referralCreationReferredJobCode(state) {
    return state.profileDetailsState.referral_creation && state.profileDetailsState.referral_creation.job_code;
  },
  referralCreationReferredJob(state) {
    return state.referralCreationReferredJob || {};
  },
  showRecommendedJobsNotFoundState(state) {
    return state.showRecommendedJobsNotFound;
  }
};
